import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './HeroModule.scss';
import './HeroModuleBC.scss';
import './HeroModuleBL.scss';
import './HeroModuleCC.scss';
import './HeroModuleWhite.scss';

const HeroModule = (props) => {
  const {
    opts = {},
    isHeroModule,
    isHeroModuleWhite,
    isHeroModuleCC,
    isHeroModuleBC,
    isHeroModuleBL
  } = props;
  const {
    id,
    ctaLink,
    heroMedia = {},
    heroMediaMobile = {},
    eventLogo = {},
    eventLogoMobile = {},
    heading,
    subHeading,
    cta,
    collectionLink,
    cornerCaption,
  } = opts;
  const wrapperClass = classNames({
    etchHero: isHeroModule,
    etchHeroWhite: isHeroModuleWhite,
    etchHeroCC: isHeroModuleCC,
    etchHeroBC: isHeroModuleBC,
    etchHeroBL: isHeroModuleBL
  });
  return (
    <div className={wrapperClass} id={id}>
      {ctaLink
        && (
          <a className={`${wrapperClass}__link`} href={ctaLink}>
            <picture className={`${wrapperClass}__media`}>
              <source media="(min-width: 640px)" srcSet={heroMedia.src} />
              {heroMediaMobile.src
              && <source media="(min-width: 0px)" srcSet={heroMediaMobile.src} />}
              {!heroMediaMobile.src
              && <source media="(min-width: 0px)" srcSet={heroMedia.src} />}
              <img className={`stretchy {${wrapperClass}__main`} src={heroMedia.src} alt={heroMedia.alt} />
            </picture>
          </a>
        )}
      {!ctaLink
        && (
          <picture className={`${wrapperClass}__media`}>
            <source media="(min-width: 640px)" srcSet={heroMedia.src} />
            {heroMediaMobile.src
            && <source media="(min-width: 0px)" srcSet={heroMediaMobile.src} />}
            {!heroMediaMobile.src
            && <source media="(min-width: 0px)" srcSet={heroMedia.src} />}
            <img className={`stretchy {${wrapperClass}__main`} src={heroMedia.src} alt={heroMedia.alt} />
          </picture>
        )}
      <div className={`${wrapperClass}__info u__text-shadow--none`}>
        {eventLogo.src
          && (
            <div className={`${wrapperClass}__logo`}>
              <img src={eventLogo.src} className={`${wrapperClass}__eventLogo`} alt={eventLogo.alt} />
            </div>
          )}
        {eventLogoMobile.src
          && (
            <div className={`${wrapperClass}__mobilelogo`}>
              <img src={eventLogoMobile.src} className={`${wrapperClass}__eventLogoMobile`} alt={eventLogoMobile.alt} />
            </div>
          )}
        <h2 className={`${wrapperClass}__heading u__display-font--black u__jumbo`}>{heading}</h2>
        {subHeading
          && <h3 className={`${wrapperClass}__subHeading u__large`}>{subHeading}</h3>}
        {cta
          && (
            <a className={`${wrapperClass}__btn bttn bttn--primary bttn--inline`} href={ctaLink}>
              <span className={`${wrapperClass}__btn__content bttn__content`}>{cta}</span>
            </a>
          )}
      </div>
      <div className={`${wrapperClass}__corner`}>
        {collectionLink
          && <a className={`${wrapperClass}__corner__caption`} href={collectionLink}>{cornerCaption}</a>}
        {!collectionLink
          && <p className={`${wrapperClass}__corner__caption`}>{cornerCaption}</p>}
      </div>
    </div>
  );
};

HeroModule.propTypes = {
  opts: PropTypes.shape({
    id: PropTypes.string,
    ctaLink: PropTypes.string,
    heroMedia: PropTypes.object,
    heroMediaMobile: PropTypes.object,
    eventLogo: PropTypes.object,
    eventLogoMobile: PropTypes.object,
    heading: PropTypes.string,
    subHeading: PropTypes.string,
    cta: PropTypes.string,
    collectionLink: PropTypes.string,
    cornerCaption: PropTypes.string,
  }).isRequired,
  isHeroModule: PropTypes.bool,
  isHeroModuleWhite: PropTypes.bool,
  isHeroModuleCC: PropTypes.bool,
  isHeroModuleBC: PropTypes.bool,
  isHeroModuleBL: PropTypes.bool,
};
HeroModule.defaultProps = {
  isHeroModule: false,
  isHeroModuleWhite: false,
  isHeroModuleCC: false,
  isHeroModuleBC: false,
  isHeroModuleBL: false,
};

export default HeroModule;
